import React from 'react';

export const DraggableIcon = () => (
	<svg
		width="18"
		height="28"
		viewBox="0 0 18 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle cx="6" cy="6" r="2" fill="#8F9095" />
		<circle cx="12" cy="6" r="2" fill="#8F9095" />
		<circle cx="6" cy="14" r="2" fill="#8F9095" />
		<circle cx="12" cy="14" r="2" fill="#8F9095" />
		<circle cx="6" cy="22" r="2" fill="#8F9095" />
		<circle cx="12" cy="22" r="2" fill="#8F9095" />
	</svg>
);
